import { render } from "./LegalIcon.vue?vue&type=template&id=5b731d24"
import script from "./LegalIcon.vue?vue&type=script&lang=js"
export * from "./LegalIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__